module.exports = __webpack_public_path__ + "static/media/veterinarian.87d9bc9d.svg";